// extracted by mini-css-extract-plugin
export default {"labelBox":"Label_labelBox__KEk+K","label":"Label_label__x8vTr"};